import React from "react";
import "../css/user.css";

function UserMine({ email, role, onDelete }) {
    return (
        <div className="user">
            <p id="emailuser" className="textlink UserField"><b>Email:</b> {email}</p>
            <p id="roleuser" className="textlink UserField"><b>Role:</b> {role}</p>
            <button
                type="submit"
                className="button buttonUser dangerbutton"
                onClick={onDelete}
            >
                Delete
            </button>
        </div>
    );
}

export default UserMine;
